'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _react = require('react');

var _analytics = require('../../redux/modules/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = null;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        saveFullStorySessionUrl: _analytics.saveFullStorySessionUrl
    }, dispatch);
};

var FullStory = function (_PureComponent) {
    (0, _inherits3.default)(FullStory, _PureComponent);

    function FullStory() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FullStory);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FullStory.__proto__ || (0, _getPrototypeOf2.default)(FullStory)).call.apply(_ref, [this].concat(args))), _this), _this.tryToSaveSessionUrl = function () {
            var sessionUrl = '';
            if (window.FS && window.FS.getCurrentSessionURL) {
                sessionUrl = window.FS.getCurrentSessionURL();
                if (sessionUrl) {
                    _this.props.saveFullStorySessionUrl(sessionUrl);
                }
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FullStory, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.tryToSaveSessionUrl();
            window['_fs_ready'] = function () {
                _this2.tryToSaveSessionUrl();
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return FullStory;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FullStory);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FullStory/FullStory.js
// module id = W0mi
// module chunks = 60